import React, {useContext, useEffect} from "react";
import { UserContext } from "../Context/UserContext";
import { useParams } from "react-router";
import { Input } from "antd";

const CreateDataMovies = () => {
   
    let {Id} = useParams()
    const {functions, input}= useContext (UserContext)
    
    const {getDataById, handleChange, handleSubmit} = functions

    useEffect (() => {
        if (Id !== undefined) {

            getDataById(Id)
        }
    }, [])

    console.log(Id)


    return (
    <>

    <div className="form-buah">
    <h1 style={{color: "white", fontSize: "35px", marginTop:"40px", textAlign:"center", fontWeight:"bold"}}>Create Your Data Movies Here!</h1>
    <form onSubmit={handleSubmit}>
      <label htmlFor="fname">Title:</label>
      <Input required onChange={handleChange} value={input.title} type="text" id="fname" name="title" placeholder="Movie's Title "/>
      <label htmlFor="lname">Description:</label>
      <Input required onChange={handleChange} value={input.description} type="text" id="lname" name="description" placeholder="Description.."/>
      <label htmlFor="lname">Year:</label>
      <Input required onChange={handleChange} value={input.year} type="number" id="lname" name="year"/>
      <label htmlFor="lname">Duration:</label>
      <Input required onChange={handleChange} value={input.duration} type="number" id="lname" name="duration" />
      <label htmlFor="lname">Genre:</label>
      <Input required onChange={handleChange} value={input.genre} type="text" id="lname" name="genre" placeholder="Genre..."/>
      <label htmlFor="lname">Rating:</label>
      <Input required onChange={handleChange} value={input.rating} type="number" id="lname" name="rating" min={1} max={10}/>
      <label htmlFor="lname">Review:</label>
      <Input required onChange={handleChange} value={input.review} type="text" id="lname" name="review" placeholder="Review..."/>
      <label htmlFor="lname">Image URL:</label>
      <Input required onChange={handleChange} value={input.image_url} type="text" id="lname" name="image_url"placeholder="url..." />
     
      <Input type="submit" value="Submit"/>
    </form>
  </div>
 

</>
    )
}

export default CreateDataMovies